import Http from '../api/http';

export default class ReportExperience extends Http {
  constructor() {
    super();
  }
  /***********在线报告用户体验描述管理***************/
  /**
   * 报告用户体验描述管理,基础信息保存
   * @param {Array} reportExperienceDto -  reportExperienceDto
   */
  reportExperience_save() {
    return super.post('reportExperience/save', ...arguments);
  }

  /**
   * @description: 报告用户体验描述详情小项添加(修改)
   * @param {type}
   * @return:
   */
  reportExperience_saveReportExperience() {
    return super.post('reportExperience/saveReportExperience', ...arguments);
  }

  /**
   * 获取报告模板
   * @returns
   */
  reportExperience_getReportTemplateTreeById() {
    return super.post('reportExperience/getReportTemplateTreeById', ...arguments);
  }

  /**
   * 获取报告树结构
   * @param {string} reportExperienceId -  用户体验描述id
   */
  reportExperience_getReportExperience() {
    return super.post('reportExperience/getReportExperience', ...arguments);
  }

  /**
   * 删除批注
   * @param {string} reportExperienceId -  用户体验描述id
   * @returns
   */
  reportExperience_clearPostil() {
    return super.post('reportExperience/clearPostil', ...arguments);
  }
  /**
   * 删除批注
   * @param {string} reportLogId -  校验版本号
   * @param {string} version
   * @returns
   */
  reportExperience_checkReportExperienceVersion() {
    return super.post('reportExperience/checkReportExperienceVersion', ...arguments);
  }
  /**
   * 获取报告的第一个报告考核点
   * @param {string} reportExperienceId -  用户体验描述id
   */
  reportExperience_getFirstReportInfoVo() {
    return super.post('reportExperience/getFirstReportInfoVo', ...arguments);
  }
  /**
   * 保存单个考核点
   */
  reportExperience_saveInfo() {
    return super.post('reportExperience/saveInfo', ...arguments);
  }
  /**
   * 根据考核点id获取报告某个考核点
   */
  reportExperience_getReportInfoVoByTemplateInfoId() {
    return super.post('reportExperience/getReportInfoVoByTemplateInfoId', ...arguments);
  }
  /**
   * 获取报告详细目录结构
   * * @param {string} reportExperienceId -  用户体验描述id
   */
  reportExperience_getReportTreeCatalog() {
    return super.post('reportExperience/getReportTreeCatalog', ...arguments);
  }
  /**
   * 获取报告分阶段详细目录结构
   * @param {string} reportExperienceId -  用户体验描述id
   */
  reportExperience_getReportTreePhaseCatalog() {
    return super.post('reportExperience/getReportTreePhaseCatalog', ...arguments);
  }
  /**
   * 获取报告缩略图目录结构
   * * @param {string} reportExperienceId -  用户体验描述id
   */
  reportExperience_getReportNumberCatalog() {
    return super.post('reportExperience/getReportNumberCatalog', ...arguments);
  }
  /**
   * 获取报告分阶段缩略图目录结构
   * @param {string} reportExperienceId -  用户体验描述id
   */
  reportExperience_getReportNumberPhaseCatalog() {
    return super.post('reportExperience/getReportNumberPhaseCatalog', ...arguments);
  }
  /**
   * 查看未提交的阶段
   * @param {string} reportLogId - 报告id
   */
  reportExperience_getUnSubmitPhase() {
    return super.post('reportExperience/getUnSubmitPhase', ...arguments);
  }
}
